module.exports = "<ul class=\"breadcrumb pull-left\">\n    <li *ngFor=\"let url_segment of _urls; let first = first; let last = last\" [ngClass]=\"{ 'hidden': (last && url == '/') }\">\n\n        <!--<a *ngIf=\"url_segment.url == prefix\" [routerLink]=\"'/'\" [ngClass]=\"{'active': last}\">{{ url_segment.label }}</a>-->\n        <a [routerLink]=\"url_segment.url\" [ngClass]=\"{'active': last}\">{{ url_segment.label }}</a>\n\n    </li>\n</ul>"


//////////////////
// WEBPACK FOOTER
// ./libs/chassis-core/src/app/layouts/components/partials/breadcrumb/breadcrumb.component.html
// module id = ./libs/chassis-core/src/app/layouts/components/partials/breadcrumb/breadcrumb.component.html
// module chunks = main